import { render, staticRenderFns } from "./NovaCobranca.vue?vue&type=template&id=be6cf02c&scoped=true"
import script from "./NovaCobranca.vue?vue&type=script&lang=js"
export * from "./NovaCobranca.vue?vue&type=script&lang=js"
import style0 from "./NovaCobranca.vue?vue&type=style&index=0&id=be6cf02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6cf02c",
  null
  
)

export default component.exports